import { Button } from "antd";
import classNames from "classnames";
import { memo } from "react";
import { Else, If, Then } from "react-if";
import HBButton from "../HBButton";
import styles from "./index.module.less";
import OperationButton from "./operationButton";
/**
 * @param {{
 *  followed: boolean,
 *  onClick: (e?:any) => void,
 *  btnText?: string,
 *  className?: string,
 *  showGrop?: boolean,
 *  userInfo?: IUser,
 *  boardInfo?: IBoard,
 *  grayFollow?: boolean,
 * }} props
 */
function FollowButton({
  followed,
  onClick,
  btnText = "关注",
  className,
  showGrop = false,
  userInfo,
  boardInfo,
  grayFollow = false,
  ...props
}) {
  return (
    <div className={classNames(styles.follow_button, className)} {...props}>
      <If condition={followed}>
        <Then>
          {showGrop ? (
            <OperationButton
              onClick={onClick}
              userInfo={userInfo}
              boardInfo={boardInfo}
            ></OperationButton>
          ) : (
            <Button type="primary" block onClick={onClick} shape="round">
              已关注
            </Button>
          )}
        </Then>
        <Else>
          <HBButton
            className={classNames({
              [styles.grayFollow]: grayFollow,
            })}
            type="primary"
            block
            onClick={onClick}
          >
            {btnText}
          </HBButton>
        </Else>
      </If>
    </div>
  );
}

export default memo(FollowButton);
